import { FormProvider } from "react-hook-form";
import { PageMode } from "../../../../common/types";
import styles from "./MyFamilyWizard.module.scss";
import { SingleSectionPageLayout } from "../../../../common/components/common/SingleSectionPageLayout";
import { useMyFamilyWizardPage } from "./hooks/useMyFamilyWizardPage";
import { HiddenField } from "../../../../common/components/forms/inputs/hiddenField/HiddenField";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { nameof } from "ts-simple-nameof";
import { IMyFamilyWizardFormModel } from "./models/myFamilyWizardFormModel";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { DefaultFormSelectField } from "../../../../common/components/forms/inputs/dropdown/DefaultFormSelectField";
import { FamilyMembers } from "./components/FamilyMembers";
import { SpecificPageNotFound } from "../../../../common/components/errorPages/SpecificPageNotFound";
import { routePaths } from "../../../../common/infrastructure/routes/routePaths";

interface IMyFamilyWizardProps {
  pageMode: PageMode;
}

export const MyFamilyWizard = ({ pageMode }: IMyFamilyWizardProps) => {
  const {
    familyData,
    isLoading,
    form,
    isDesktopOrTablet,
    pageTitle,
    handleSubmit,
    navigate,
  } = useMyFamilyWizardPage(pageMode);

  if (!familyData && !isLoading) {
    return (
      <SpecificPageNotFound
        text={"За съжаление нямате достъп до тази страница."}
        buttonText={"Обратно към 'Моето семейство'"}
        onButtonClick={() => navigate(routePaths.portalMyFamily)}
      />
    );
  }

  const children = (
    <div className={styles.root_fields}>
      <HiddenField name={nameof<IMyFamilyWizardFormModel>((x) => x.id)} />

      <DefaultInputField
        name={nameof<IMyFamilyWizardFormModel>((x) => x.name)}
        label="Име"
        placeholder="Георгиеви"
        width={isDesktopOrTablet ? "600px" : "80%"}
        required
      />

      <FamilyMembers
        familyMembers={familyData?.members}
        familyId={familyData?.id ?? 0}
      />

      <DefaultFormSelectField
        name={nameof<IMyFamilyWizardFormModel>((x) => x.familyHeadId)}
        label="Отговорник на семейството"
        tooltip="Отговорникът на семейството може да прави резервации от името на всеки член на семейството. Той също така може да управлява семейството."
        disabled={!familyData?.members}
        options={familyData?.members ?? []}
      />
      <div className={styles.root_buttons}>
        <DefaultButton label={"Запазване"} type="submit" />
      </div>
    </div>
  );
  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)}>
        <SingleSectionPageLayout
          title={pageTitle}
          maxHeight={"auto"}
          height="auto"
          children={children}
        />
      </form>
    </FormProvider>
  );
};
